import Vue from 'vue'

const vue = Vue.prototype

const state = {
  kakaoData: null,
  loginDialog: false,
  loginRequestCount: 0
}
export default {
  namespaced: true,
  state,
  mutations: {
    INCREASE_COUNT(state){
      state.loginRequestCount++
    },
    SET_LOGIN_DIALOG(state, payload){
      state.loginDialog = payload
    },
    SET_KAKAO_DATA(state, payload){
      state.kakaoData = payload
    }
  },
  actions: {
    openLoginDialog({commit, state}) {
      commit('SET_LOGIN_DIALOG',!state.loginDialog)
    },
    logout({commit}) {
      const player = vue.$session.get('loginUser')
      vue.$session.destroy()
      vue.$alert('',`${player.name}님 로그아웃 되었습니다`, 'success')
      commit('INCREASE_COUNT')
    },
    setKakaoData({commit}, kakaoData){
      const player = {
        name: kakaoData.properties.nickname,
        meta: {
          image: kakaoData.properties.profile_image
        },
        kakao_id: kakaoData.id,
      }
      commit('SET_KAKAO_DATA',{player,...kakaoData})
    },
    login({commit}, player){
      vue.$session.start()
      vue.$session.set('loginUser',player)

      vue.$alert(`환영합니다 ${player.name}님`,'로그인 성공', 'success')
      commit('INCREASE_COUNT')
    }
  }
}